import { books } from '@data/siteData';
import { Card, CardContent, CardHeader, CardTitle } from '@components/ui/Card';
import { BookOpen, Tag } from 'lucide-react';

export default function LiteraturPage() {
  return (
    <div className="py-12 bg-slate-950 min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-10">
          <h1 className="text-3xl sm:text-4xl font-bold text-white mb-4">Literatur</h1>
          <p className="text-lg text-slate-400">
            Bücher zur Geschichte der Mannheimer Sternwarte und der Künstler, die dort
            arbeiteten.
          </p>
        </div>

        {/* Books */}
        <div className="space-y-6">
          {books.map((book, index) => (
            <Card key={index}>
              <CardHeader>
                <div className="flex items-start gap-4">
                  <div className="w-14 h-14 bg-blue-600/10 rounded-lg flex items-center justify-center shrink-0">
                    <BookOpen className="text-blue-400" size={28} />
                  </div>
                  <div className="flex-1">
                    <CardTitle className="text-xl mb-2">{book.title}</CardTitle>
                    <p className="text-slate-400">{book.publisher}</p>
                  </div>
                </div>
              </CardHeader>
              <CardContent>
                <p className="text-slate-300 mb-4">{book.description}</p>

                <div className="flex flex-wrap gap-2 mb-4">
                  {book.series && (
                    <span className="px-3 py-1 bg-purple-900/30 text-purple-300 rounded-full text-sm">
                      {book.series}
                    </span>
                  )}
                  <span className="px-3 py-1 bg-slate-800 text-slate-300 rounded-full text-sm">
                    {book.pages} Seiten
                  </span>
                  <span className="px-3 py-1 bg-slate-800 text-slate-300 rounded-full text-sm">
                    {book.language}
                  </span>
                  {book.features && (
                    <span className="px-3 py-1 bg-slate-800 text-slate-300 rounded-full text-sm">
                      {book.features}
                    </span>
                  )}
                </div>

                <div className="flex flex-wrap items-center gap-4 pt-4 border-t border-slate-800">
                  <div className="flex items-center gap-2">
                    <Tag size={16} className="text-slate-500" />
                    <span className="text-slate-400 text-sm">ISBN: {book.isbn}</span>
                  </div>
                  <div className="text-green-400 font-semibold">{book.price}</div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}
